// extracted by mini-css-extract-plugin
export default {"mainContainer":"Dashboard_mainContainer__Nlu2T","dash":"Dashboard_dash__88oVe"};